const SpecLoadMore = (contentId: string) => {
  const contentContainer = document.getElementById(contentId);

  if (!contentContainer) {
    return;
  }

  const hfsGridTiles =
    contentContainer.querySelectorAll<HTMLElement>('.hfs-grid-tile');

  const loadMoreBtn = contentContainer.querySelector<HTMLButtonElement>(
    '.js-m-spec-load-more',
  );

  let visibleCount: number = 3;
  let currentVisibleCount: number = 0;

  const showItems = (count: number): void => {
    for (
      let i = currentVisibleCount;
      i < currentVisibleCount + count && i < hfsGridTiles.length;
      i++
    ) {
      hfsGridTiles[i].classList.add('active'); // Add the 'active' class to show the item
    }
    currentVisibleCount += count;
  };

  const loadMoreItems = () => {
    const hiddenItems = Array.from(hfsGridTiles).filter(
      item => !item.classList.contains('active'),
    );

    // Show the next batch of hidden items
    const itemsToShow = hiddenItems.slice(0, visibleCount);
    itemsToShow.forEach(item => {
      item.classList.add('active'); // Add the 'active' class
    });

    // Hide the "Load More" button if no more hidden items
    if (hiddenItems.length <= visibleCount) {
      if (loadMoreBtn) {
        loadMoreBtn.style.display = 'none';
      }
    }
  };

  const init = () => {
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', loadMoreItems);
    }
  };

  const updateVisibleCount = () => {
    visibleCount = 3;

    // Reset current visible count
    currentVisibleCount = 0;

    // Remove the 'active' class from all items initially
    hfsGridTiles.forEach(item => {
      item.classList.remove('active');
    });

    showItems(visibleCount); // Show the new number of items
  };

  // Show the initial number of items
  showItems(visibleCount);

  // Show the Load More button if needed
  if (loadMoreBtn) {
    loadMoreBtn.style.display = 'inline-block';
  }

  init(); // Initialize the event listeners
};

export default SpecLoadMore;
